module.exports = __webpack_public_path__ + "img/020-navy.06c55c3c.png";